/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SectionRequirementCoverageRetrieval = {
    uuid: string;
    requirement_set: string;
    requirement: string;
    requirement_identifier: string;
    coverage?: SectionRequirementCoverageRetrieval.coverage;
    gap_description?: string;
}

export namespace SectionRequirementCoverageRetrieval {

    export enum coverage {
        UNKNOWN = 'unknown',
        NONE = 'none',
        PARTIAL = 'partial',
        FULL = 'full',
    }


}
